import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardContent,
  Button,
  Container,
  Grid,
  Typography,
  CardActions,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import { DRIVER_FORM } from "navigation/CONSTANTS";

const useStyles = makeStyles((theme) => ({
  header: {
    border: `1px solid #dadce0`,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderTopWidth: 10,
    borderTopColor: theme.palette.primary.main,
    marginTop: 10,
    borderRadius: 8,
  },
  root: {
    minWidth: "80%",
  },
}));

function DriverFormSuccess() {
  const classes = useStyles();
  const history = useHistory();

  const onSubmit = () => {
    history.push(DRIVER_FORM);
  };

  useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnv = document.querySelector(".imtime-testEnvironment");
    if (header) header.style.display = "none";
    if (testEnv) testEnv.style.display = "none";
  }, []);

  return (
    <>
      <Container maxWidth="sm">
        <Grid container direction="column" alignItems="stretch" spacing={2}>
          <Grid item>
            <Card className={classes.header}>
              <CardContent>
                <Typography variant="h6" gutterBottom color="textPrimary">
                  Thank You!
                </Typography>
                <Typography variant="body" gutterBottom color="textPrimary">
                  Your form is successfully submitted.
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="medium" color="primary" onClick={onSubmit}>
                  Submit Another Form
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default DriverFormSuccess;
